export const UPDATE_GAMMA_STATE = "UPDATE_GAMMA_STATE";
export const INCREMENT_SYNC_QUEUE = "INCREMENT_SYNC_QUEUE";
export const DECREMENT_SYNC_QUEUE = "DECREMENT_SYNC_QUEUE";
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const UPDATE_LAST_MAP_COUNT = "UPDATE_LAST_MAP_COUNT";
export const UPDATE_TAWK_BOT = "UPDATE_TAWK_BOT";
export const UPDATE_DISPLAY_SETTINGS = "UPDATE_DISPLAY_SETTINGS"
export const UPDATE_IMAGE_LOAD_PROGRESS = "UPDATE_IMAGE_LOAD_PROGRESS"
export const UPDATE_LAST_IMAGE_RENDER_TIME = "UPDATE_LAST_IMAGE_RENDER_TIME"
export const UPDATE_GAMMA_FOLDER = "UPDATE_GAMMA_FOLDER"
export const UPDATE_GAMMA_CASE_IDX = "UPDATE_GAMMA_CASE_IDX"
export const UPDATE_MAGIC_TOOL_DATA_RETRIEVAL = "UPDATE_MAGIC_TOOL_DATA_RETRIEVAL"
